var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIraqCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 250,
    viewBox: "0 0 650 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_22)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H90V250H0V0Z",
    fill: "#C0162D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 0H180V250H90V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 0H560V250H470V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 0H650V250H560V0Z",
    fill: "#C0162D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 0H142V250H127V0Z",
    fill: "#093800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 0H522V250H507V0Z",
    fill: "#093800"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    width: 65,
    height: 250,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405,
    width: 65,
    height: 250,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    width: 160,
    height: 250,
    fill: "#FFEE70"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIraqCampaign);
export default __webpack_public_path__ + "static/media/Iraq Campaign.e2fcfd130ae69cd0039db5aed2c032a9.svg";
export { ForwardRef as ReactComponent };